var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewspaper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.625 3.03437L16.9416 3.7177L16.15 2.9177C15.825 2.5927 15.3 2.5927 14.9666 2.9177L14.1666 3.7177L13.3666 2.9177C13.0416 2.5927 12.5083 2.5927 12.1833 2.9177L11.3916 3.7177L10.5916 2.9177C10.2666 2.5927 9.74163 2.5927 9.41663 2.9177L8.61663 3.7177L7.81663 2.9177C7.49163 2.5927 6.96663 2.5927 6.63329 2.9177L5.83329 3.7177L5.03329 2.9177C4.70829 2.5927 4.17496 2.5927 3.84996 2.9177L3.05829 3.7177L2.37496 3.03437C2.11663 2.77603 1.66663 2.95937 1.66663 3.33437V15.6594C1.66663 16.576 2.41663 17.326 3.33329 17.326H16.6666C17.5833 17.326 18.3333 16.576 18.3333 15.6594V3.33437C18.3333 2.95937 17.8833 2.77603 17.625 3.03437ZM9.16663 15.6594H3.33329V10.6594H9.16663V15.6594ZM16.6666 15.6594H10.8333V13.9927H16.6666V15.6594ZM16.6666 12.326H10.8333V10.6594H16.6666V12.326ZM16.6666 8.9927H3.33329V6.4927H16.6666V8.9927Z",
    fill: "#29C1DB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewspaper);
export default __webpack_public_path__ + "static/media/newspaper.7738e093c89fda216d09d042f275fa24.svg";
export { ForwardRef as ReactComponent };